/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import _ from 'lodash';
import {Ng2StateDeclaration} from '@uirouter/angular';
import {AdminResourceItemRoutePageComponent} from '../../common/controller/admin-resource-item-route-page.component';
import {AdminResourceContextRoutePageComponent} from '../../common/controller/admin-resource-context-route-page.component';
import {getRoutePageComponent, getContextRoutePageComponent} from '../../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../../routing/state-utils';
import {adminResourceItemRouteResolve} from '../../common/controller/admin-resource-routing';
import {CustomEventResource} from '../../../components/api/resources/resource/custom-event.resource';


export function customEventStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
let rh = adnRouterHelperProvider.$get().createRouterHelper('custom-events.custom-event', CustomEventResource, 'app.adm', 'app/admin');
    
        $stateProvider.state(rh.listPath(), rh.list({
          views: {
            'content@app': { component: getRoutePageComponent('custom-event-route') }
          }
        }));
    
        $stateProvider.state(rh.newItemPath(), rh.newItem());
    
        $stateProvider.state(rh.itemPath(), rh.modelCommsItem({
          resolve: _.merge({}, adminResourceItemRouteResolve('custom-event-edit', 'edit')),
            views: {
            'content@app': { component: AdminResourceItemRoutePageComponent, bindings: { item: 'adminResourceItemKey', variant: 'adminResourceItemVariant' }  },
            'context@app': {component: AdminResourceContextRoutePageComponent}
          }
        }, 'CustomEvent'));
  }, adnRouterHelper);
}
